
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/orders/[token]/reorder",
      function () {
        return require("private-next-pages/account/orders/[token]/reorder.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/orders/[token]/reorder"])
      });
    }
  